export type MediaExtension =
  | 'jpg'
  | 'jpeg'
  | 'png'
  | 'gif'
  | 'bmp'
  | 'webp' // Image
  | 'mp4'
  | 'avi'
  | 'mov'
  | 'mkv'
  | 'webm' // Video
  | 'txt' // Text
  | 'html' // Iframe
  | 'svg';

export type MediaCategoryType = 'image' | 'video' | 'txt' | 'iframe' | 'unknown';

export const MEDIA_EXTENSION_MAP: Record<MediaExtension, MediaCategoryType> = {
  // Images
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  gif: 'image',
  bmp: 'image',
  webp: 'image',
  svg: 'image',

  // Videos
  mp4: 'video',
  avi: 'video',
  mov: 'video',
  mkv: 'video',
  webm: 'video',

  // Text
  txt: 'txt',

  // Iframe
  html: 'iframe',
};
